import { useState } from 'react'
import { Provider, inject, observer } from 'mobx-react'
import { Route, Routes } from 'react-router'

import AccountStore from './AccountStore'
import Dashboard from './dashboard/Dashboard'
import Overview from './overview/Overview'
import UpdateBalances from './update-balances/UpdateBalances'
import AddAccount from './AddAccount'
import AddIntro from './intro/AddIntro'
import AddBasics from './basics/AddBasics'
import AddContributions from './contributions/AddContributions'
import AddPaycheckContributions from './contributions/AddPaycheckContributions'
import AddEmployerContributions from './contributions/AddEmployerContributions'
import AddPayout from './payout/AddPayout'
import AddInvestmentsIntro from './investments/AddInvestmentsIntro'
import AddInvestments from './investments/AddInvestments'
import AddNewInvestment from './investments/AddNewInvestment'
import { UploadStatementModal, UploadStatementPage } from './investments/upload'
import AddAnnuity from './annuity/AddAnnuity'
import StockOptions from './stock-options/StockOptions'
import DuplicateAccount from './duplicate-account/DuplicateAccount'

const Accounts = ({ store }) => {
  const [state] = useState(() => AccountStore.create({ account: null }, { store }))
  return (
    <Provider account={state}>
      <Routes>
        <Route path='/add/:type/:accountType/intro' element={<AddIntro />} />
        <Route path='/add/:type/:accountType/duplicate-account' element={<DuplicateAccount />} />
        <Route path='/add/:type/:accountType/basics' element={<AddBasics />} />
        <Route path='/add/:type/:accountType/:id/contributions' element={<AddContributions />} />
        <Route
          path='/add/:type/:accountType/:id/paycheck-contributions'
          element={<AddPaycheckContributions />}
        />
        <Route
          path='/add/:type/:accountType/:id/employer-contributions'
          element={<AddEmployerContributions />}
        />
        <Route path='/add/:type/:accountType/payout' element={<AddPayout />} />
        <Route
          path='/add/:type/:accountType/:id/investments-intro'
          element={<AddInvestmentsIntro />}
        />
        <Route path='/add/:type/:accountType/:id/annuity' element={<AddAnnuity />} />
        <Route path='/add/:type/:accountType/:id/investments' element={<AddInvestments />} />
        <Route path='/add/:type/:accountType/:id/investment' element={<AddNewInvestment />} />
        <Route
          path='/add/:type/:accountType/:id/upload-statement'
          element={<UploadStatementPage />}
        />
        <Route path='/add' element={<AddAccount />} />
        <Route path='/:type/:accountType/:id/update-balances' element={<UpdateBalances />} />
        <Route path='/:type/:accountType/:id' element={<Overview />} />
        <Route path='/stock-options' element={<StockOptions />} />
        <Route path='/' element={<Dashboard />} />
      </Routes>
      {/* One modal for the whole subtree; the account it targets lives on the app store. */}
      <UploadStatementModal />
    </Provider>
  )
}

export default inject('store')(observer(Accounts))
